/**
 * Trash (delete) icon
 * Story 292: Delete tasks from web UI with coverage warning
 *
 * SVG trash can icon for delete actions.
 */

interface TrashIconProps {
  /** Icon size in pixels (default: 16) */
  size?: number;
  /** Additional CSS class */
  className?: string;
}

export function TrashIcon({ size = 16, className }: TrashIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Lid */}
      <polyline points="3 6 5 6 21 6" />
      {/* Can body */}
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
      {/* Handle */}
      <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      {/* Lines inside */}
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  );
}
